"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var middleware_stack_1 = require("@aws-sdk/middleware-stack");
var Command = /** @class */function () {
  function Command() {
    this.middlewareStack = new middleware_stack_1.MiddlewareStack();
  }
  return Command;
}();
exports.Command = Command;